import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Agent runs reference their conversation as "(dialogue #N)" in the run
// message — render that reference as a link into the chat view wherever
// the message text appears (runs table, jobs list status, run view).
const DIALOGUE_REF_PATTERN = /\(dialogue #(\d+)\)/;

const DialogueRefText = ({ text, testId }) => {
  const message = text || "";
  const match = message.match(DIALOGUE_REF_PATTERN);
  if (!match) {
    return message;
  }
  const [reference, dialogueId] = match;
  const start = message.indexOf(reference);
  return (
    <>
      {message.slice(0, start)}
      <Link to={`/assistant/chat/${dialogueId}`} data-testid={testId}>
        {reference}
      </Link>
      {message.slice(start + reference.length)}
    </>
  );
};

DialogueRefText.propTypes = {
  text: PropTypes.string,
  testId: PropTypes.string,
};

export default DialogueRefText;
